import { render, staticRenderFns } from "./onhand-detail-report.vue?vue&type=template&id=17af2d72"
import script from "./onhand-detail-report.vue?vue&type=script&lang=js"
export * from "./onhand-detail-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports